import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CxoneEtlReportingSetService } from "../../../cxone-etl-reporting-set.service";
import { ETLReportingSetFlowbuilderModules, ETLReportingSetObj, EmployeeGroupListType, HierarchyGroup, ParentOutputFormType, EMPHIERARCHY } from "../../../cxone-etl-reporting-set.model";

@Component({
    selector: "cv-employee-group",
    templateUrl: "./employee-group.component.html",
    styleUrls: ["./employee-group.component.scss"],
})
export class EmployeeGroupComponent implements OnInit {
    @Output() employeeHierarchyData = new EventEmitter();
    @Input() selectedSection = "";
    @Input() reportingSetName = "";
    @Input() set hierarchyEmployeeGroupClickedItem(data) {
        if (data) {
            this.updateSelectedSectionItem(data);
        }
    }
    public selectedSectionItem = "";
    public employeeHierarchyList: EmployeeGroupListType[];
    public employeeGroupList: EmployeeGroupListType[];
    public checkbox = false;
    private selectedItem: EmployeeGroupListType = null;

    constructor(private cxoneEtlReportingSet: CxoneEtlReportingSetService) { }

    async ngOnInit() {
        await this.initializeEmployeeGroupData();
    }

    async initializeEmployeeGroupData() {
        const hierarchyGroup = await this.cxoneEtlReportingSet.getHierarchyGroups();
        let empKeyObjs: string[] = [];
        const reportingSetData: ETLReportingSetObj = this.cxoneEtlReportingSet.getReportingSetData();
        let empHierarchyData = {};
        if (reportingSetData && Object.keys(reportingSetData).length) { // we have some existing data 
            // Iterate over EMPHIERARCHY to map keys
            EMPHIERARCHY.forEach((key, index) => {
                // Find the key in reportingSetData.EmpHierarchy based on index
                const reportingSetKey = Object.keys(reportingSetData.EmpHierarchy)[index];
                if (reportingSetKey) {
                    // Assign the value to empHierarchyData with the corresponding key from EMPHIERARCHY
                    empHierarchyData[key] = reportingSetData.EmpHierarchy[reportingSetKey];
                }
            });
            const empHierarchyDataExist = Object.keys(empHierarchyData).length !== 0;
            empKeyObjs = empHierarchyDataExist && Object.keys(empHierarchyData);
        }
        this.employeeHierarchyList = hierarchyGroup
            .filter((item: HierarchyGroup) => item.BaseGroupType === 0)
            .sort((a, b) => b.GroupLevel - a.GroupLevel)
            .map((empObj) => {
                let employeeObj: EmployeeGroupListType = {
                    GroupTypeName: empObj.GroupTypeName,
                    GroupData: empObj
                };
                if (empKeyObjs.length) {
                    empKeyObjs.sort();
                    const lowercaseEmpKeyObjs = empKeyObjs.map(key => key.toLowerCase());
                    const lowercaseGroupTypeName = empObj.GroupTypeName.toLowerCase().replace(/\s/g, '');
                    const matchingIndex = lowercaseEmpKeyObjs.findIndex(key => key.includes(lowercaseGroupTypeName));
                    if (matchingIndex !== -1) {
                        employeeObj.GroupData = { [empKeyObjs[matchingIndex]]: empHierarchyData[empKeyObjs[matchingIndex]] };
                        empKeyObjs.splice(matchingIndex, 1);
                    }
                }
                return employeeObj;
            });
    }

    handleClicked(event, item: EmployeeGroupListType) {
        this.selectedItem = item;
        this.employeeHierarchyData.emit(item);
    }

    updateSelectedSectionItem(item) {
        this.selectedSectionItem = item?.GroupTypeName || item?.selectedItem;
        if (this.selectedItem) {
            this.cxoneEtlReportingSet.updateData({ selectedSectionName: this.selectedSectionItem, isNew: !this.toggleStatusCompletedIcon(this.selectedItem.GroupData) });
        }
    }

    setEmployeeGroupPayload(payload: ParentOutputFormType, selectedEmployeeGroup: string) {
        this.employeeHierarchyList = this.employeeHierarchyList.map((empGrp) => {
            if (empGrp.GroupTypeName === selectedEmployeeGroup) {
                empGrp.GroupData = payload;
            }
            return empGrp;
        })
    }
    
    toggleStatusCompletedIcon(groupData) {
        return Object.keys(groupData).length === 1;
    }
}
